import { useState, useEffect } from 'react';
import { API_CONFIG } from './../../config';

const SubcriptionOffer = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.SUBCRIPTIONOFFERTIME}`;


const SubcriptionOfferTime = () => {
    const [subcriptionOffer, setSubcriptionOffer] = useState([]);
    const [subcriptionOfferLoading, setSubcriptionOfferLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(SubcriptionOffer);
                if (!response.ok) throw new Error('Network response was not ok');

                const data = await response.json();
                if (data.success) {
                    setSubcriptionOffer(data.data || []);
                }
            } catch (err) {
                console.error("Fetch  error:", err);
            } finally {
                setSubcriptionOfferLoading(false);
            }
        };
        fetchUsers();
    }, []);


    return { subcriptionOffer, subcriptionOfferLoading };
};

export default SubcriptionOfferTime;